import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Button } from "../components/ui/Button";
import { Icon } from "../app/Icon";
import { FunctionsError } from "../lib/functions-client";
import { acceptInvite } from "../lib/orgs";

export function AcceptInvite() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [state, setState] = useState<"working" | "ok" | "error">("working");
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!token) {
      setState("error");
      setMessage("This invite link is missing its token.");
      return;
    }
    acceptInvite(token)
      .then(() => setState("ok"))
      .catch((e) => {
        setState("error");
        setMessage(e instanceof FunctionsError ? e.message : "Could not accept this invite.");
      });
  }, [token]);

  return (
    <div className="mx-auto grid w-full max-w-md justify-items-center gap-4 rounded-card border border-line bg-surface p-8 text-center">
      {state === "working" && <p className="font-mono text-sm text-muted">Accepting your invite…</p>}
      {state === "ok" && (
        <>
          <span className="grid h-14 w-14 place-items-center rounded-full border-2 border-verified/40 text-verified"><Icon name="verify" className="h-7 w-7" /></span>
          <h1 className="font-display text-2xl font-black tracking-tight">You're on the team</h1>
          <p className="text-sm text-muted">You've joined the organization.</p>
          <Link to="/organizations"><Button>Go to organizations</Button></Link>
        </>
      )}
      {state === "error" && (
        <>
          <span className="grid h-14 w-14 place-items-center rounded-full border-2 border-danger/40 text-danger"><Icon name="security" className="h-7 w-7" /></span>
          <h1 className="font-display text-2xl font-black tracking-tight">Invite problem</h1>
          <p className="font-mono text-sm text-danger">{message}</p>
          <Link to="/organizations" className="text-sm font-bold text-accent-strong">Go to organizations →</Link>
        </>
      )}
    </div>
  );
}
